"use strict";
/**
 * Feedback Domain — DynamoDB Database Record Types
 *
 * Records for user feedback/access requests and field suggestion messages.
 */
Object.defineProperty(exports, "__esModule", { value: true });
